/** Nombre de colonnes d'une section de l'e-mail. */
export enum EMAIL_ROW_TYPE {
    SINGLE = 'SINGLE',
    DOUBLE = 'DOUBLE',
    TRIPLE = 'TRIPLE',
}
